import { render } from "./MainApp.vue?vue&type=template&id=8a321058"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=8a321058&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__